import { apiRequestEnvelope } from '@scc/lib'
import { toApiDate } from '@/lib/api-date'
import type { DataFreshness, DateRange } from '@/modules/shared/types'
import type { LiveSession } from '@/modules/videos/types'

export interface LiveSessionsResult {
  sessions: LiveSession[]
  livePctOfGmv: number | null
  truncated: boolean
  freshness: DataFreshness | null
}

interface LiveSessionsMeta {
  livePctOfGmv?: number | null
  truncated?: boolean
  // Currently a deliberate stub from the backend ({dataThrough: null,
  // partialDates: []}) because tiktok_shop_lives has no
  // latest_available_date column yet. When the backend wires this up, the
  // notice below starts rendering with no frontend change required.
  freshness?: DataFreshness
}

export function createApiLivesRepository() {
  return {
    async getLiveSessions(clientId: string, range: DateRange): Promise<LiveSessionsResult> {
      const { data, meta } = await apiRequestEnvelope<LiveSession[], LiveSessionsMeta>(
        `/analytics/lives?start=${toApiDate(range.from)}&end=${toApiDate(range.to)}`,
        { headers: { 'X-Store-Id': clientId } },
      )
      return {
        sessions: data ?? [],
        livePctOfGmv: meta?.livePctOfGmv ?? null,
        truncated: meta?.truncated ?? false,
        freshness: meta?.freshness ?? null,
      }
    },
  }
}

export const livesRepository = createApiLivesRepository()
